// TelcoTrack - Map search labels for objects (rozvaděč name + stavba/city)

export interface MapSearchStavbaInput {
  name?: string | null;
  kiaCode?: string | null;
}

/** Construction / city label — polygon name first, then KIA. */
export function formatMapSearchStavbaLabel(
  input?: MapSearchStavbaInput | null,
): string {
  const name = (input?.name ?? '').trim();
  if (name) return name;
  return (input?.kiaCode ?? '').trim();
}

export interface MapSearchObjectSubtitleInput {
  type?: string | null;
  parcelNumber?: string | null;
  stavbaLabel?: string | null;
}

/**
 * Object result subtitle. Named rozvaděče show the stavba they are drawn to
 * (`DP3` title + `Rozvaděč · Kutná Hora`) so the same name on several stavby
 * can be told apart. Same name is unique per stavba (product rule, not a DB constraint).
 */
export function formatMapSearchObjectSubtitle(
  input: MapSearchObjectSubtitleInput,
): string {
  const type = (input.type ?? '').trim().toUpperCase();
  const stavba = (input.stavbaLabel ?? '').trim();
  if (type === 'ROZVADEC') {
    return stavba ? `Rozvaděč · ${stavba}` : 'Rozvaděč';
  }
  if (stavba) {
    return (input.parcelNumber ?? '').trim()
      ? `Parcela · ${stavba}`
      : `Objekt · ${stavba}`;
  }
  return (input.parcelNumber ?? '').trim() ? 'Parcela' : 'Objekt';
}
